// extracted by mini-css-extract-plugin
export default {"pawLoader":"_345j-IEEc33BwEFVQkrqux","animatePawLoader":"_33I8m-z6ff1BfXDh8C9hDW"};